// extracted by mini-css-extract-plugin
export default {"formPanel":"TimelineForm_formPanel__mwPKe","slideDown":"TimelineForm_slideDown__W6B0b","panelHeader":"TimelineForm_panelHeader__5q4f3"};